// Utility functions for hero image loading functionality

/**
 * Creates shimmer placeholder items for carousel
 * @param {number} count - Number of shimmer items to create
 * @param {string} type - Type of media (image, 360, video)
 * @returns {Array} Array of shimmer placeholder items
 */
export const createShimmerPlaceholderItems = (count = 10, type = 'image') => {
  const shimmerItems = [];
  
  for (let i = 0; i < count; i++) {
    shimmerItems.push({
      type: type,
      data: {
        isShimmer: true,
        shimmerIndex: i,
        output_image_hres_url: 'https://via.placeholder.com/800x600/f0f0f0/c0c0c0?text=Loading...',
        image_id: `shimmer_${type}_${i}`,
        image_category: type === 'image' ? 'exterior' : type
      },
      category: type === 'image' ? 'exterior' : type,
      isShimmer: true
    });
  }
  
  return shimmerItems;
};

/**
 * Creates a hero image item for the carousel
 * @param {Object} heroImageData - Hero image data
 * @param {number} index - Index where hero image should be placed
 * @returns {Object} Hero image carousel item
 */
export const createHeroImageItem = (heroImageData, index = 2) => {
  return {
    type: 'image',
    data: {
      ...heroImageData,
      isHeroImage: true,
      heroIndex: index
    },
    category: 'exterior',
    isHeroImage: true
  };
};

/**
 * Generates carousel items for hero image mode
 * @param {Object} params - Parameters object
 * @param {string} heroImageUrl - URL of the hero image (optional, uses placeholder if not provided)
 * @returns {Array} Array of carousel items with hero image at index 1 and shimmer placeholders
 */
export const generateHeroImageCarouselItems = (params, heroImageUrl = null) => {
  const totalItems = 15; // Total number of items to show
  const heroImageIndex = 1; // Index where hero image should be placed
  
  // Create shimmer placeholders for all positions
  const shimmerItems = createShimmerPlaceholderItems(totalItems, 'image');
  
  // Create hero image data
  const heroImageData = {
    image_id: 'hero_image_main',
    output_image_hres_url: heroImageUrl,
    image_category: 'exterior',
    isHeroImage: true,
    heroIndex: heroImageIndex
  };
  
  // Replace the shimmer item at heroImageIndex with actual hero image
  shimmerItems[heroImageIndex] = createHeroImageItem(heroImageData, heroImageIndex);
  
  return shimmerItems;
};

/**
 * Checks if hero image mode is enabled based on query parameters
 * @param {Object} params - Parameters object from getParams
 * @returns {boolean} True if hero image mode is enabled
 */
export const isHeroImageModeEnabled = (params) => {
  return params?.heroImage === 'true' && params?.enterpriseId && params?.skuName;
};
